import { Stack } from "@material-ui/core";
import { Box } from "@material-ui/system";
import wetezLogo from "src/assets/images/wetez_logo2.svg";
import { CustomButton } from "src/components/CustomButton";
import { CustomRouterLink } from "src/components/CustomRouterLink";
import { HeaderLink } from "src/components/HeaderLink";
import { HeaderMenu } from './HeaderMenu';
import validator_icon from 'src/assets/images/validator_icon.svg';
import infrastructure_icon from 'src/assets/images/infrastructure_icon.svg';
import appchain_icon from 'src/assets/images/appchain_icon.svg';
import stakeshot_icon from 'src/assets/images/stakeshot_icon.svg';
import wallet_icon from 'src/assets/images/wallet_icon.svg'
import { useLocation } from "react-router-dom";

export const AppHeader = () => { 
  const location = useLocation(); 
  const getBgColor=()=>{
    if(['/stakingPools','/web3','/appchain'].includes(location.pathname) ){
      return "linear-gradient(to right,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#E4F0FF)"
    }
    if(['/stakeshot'].includes(location.pathname) ){
      return "#FFFFFF"
    }
    return "linear-gradient(to right, #D6D2FD, #FBD0DE, #FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF)"
  }
  return (
    <Box style={{
      background: getBgColor()
    }} display="flex" justifyContent="center">
      <Box
        width="1280px"
        p="0 20px 0 40px"
        sx={{
          height: "70px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CustomRouterLink to={"/staking"}>
          <img src={wetezLogo} width="88px" height="26px" alt="logo" />
        </CustomRouterLink>

        <Stack direction="row" alignItems="center">

          <HeaderMenu text="NODE" horizontal={-45}
            menuItems={[
              { icon: validator_icon, text: "Validator", link: "/stakingPools" },
              { icon: infrastructure_icon, text: "Infrastructure", link: "/web3" },
              { icon: appchain_icon, text: "Appchain", link: "/appchain" }
            ]}
          />
          <HeaderMenu text="TOOL" horizontal={-45}
            menuItems={[
              { icon: stakeshot_icon, text: "Stakeshot", link: "/stakeshot" },
              { icon: wallet_icon, text: "Wallet", link: "/wallet" }, 
            ]}
          />
          {/* <Box mr={7}>
            <HeaderLink targetUrl="/wallet">WALLET</HeaderLink>
          </Box> */}
          <Box mr={7}>
            <HeaderLink targetUrl="https://rpc.wetez.io" isExternal>API</HeaderLink>
          </Box>
          <Box mr={6}>
            <HeaderLink
              targetUrl="https://medium.com/@wetezvalidator"
              isExternal
            >
              BLOG
            </HeaderLink>
          </Box>

          {/* <CustomButton
            padding="8px"
            fontSize="16px"
            onClick={() => {
              window.open("https://t.me/wetezstaking");
            }}
          >
            Join Community
          </CustomButton> */}
        </Stack>
      </Box>
    </Box>
  );
};
